import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;

    span {
      width: 160px;
      background: ${theme.colors.veryDarkBlue};
      padding: 8px 0 8px 12px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      opacity: 0;
      visibility: hidden;
      position: absolute;
      bottom: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      transition: opacity 0.4s;

      &::before {
        content: '';
        border-style: solid;
        border-color: ${theme.colors.veryDarkBlue} transparent;
        border-width: 6px 6px 0 6px;
        top: 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &:hover span {
      opacity: 1;
      visibility: visible;
    }
  `}
`;
